export default {plugin:{ui_plugin_demo:{ui:{msg:'UI 插件示例'}}}};